import { s } from "@kosmod/pancake";

export type Vector4 = {
  x: number,
  y: number,
  z: number,
  w: number,
};
export const Vector4 = s.o({
  x: s.num,
  y: s.num,
  z: s.num,
  w: s.num,
})

export type Vector3 = {
  x: number,
  y: number,
  z: number,
}
export const Vector3 = s.o({
  x: s.num,
  y: s.num,
  z: s.num,
})

export type Vector2 = {
  x: number,
  y: number,
};
export const Vector2 = s.o({
  x: s.num,
  y: s.num,
})

/**
 * A position+rotation combination
 */
export type Transform = {
  position: Vector3,
  rotation: Vector4,
}
export const Transform = s.ref<Transform>()(s.o({
  position: Vector3,
  rotation: Vector4,
}));


export type FullTransform = {
  position: Vector3,
  scale: Vector3,
  rotation: Vector4,
}
export const FullTransform = s.ref<FullTransform>()(s.o({
  position: Vector3,
  rotation: Vector4,
  scale: Vector3,
}));
